import { Decimal } from 'decimal.js';
import { z } from 'zod';

/**
 * Runtime schema for a single custom field value as it arrives over tRPC
 * (SuperJSON revives `Date` natively and `Decimal` via the registered custom
 * transformer). Mirrors `CustomFieldValue` from
 * `@shared/constants/business/field-configuration`.
 *
 * A date range cleared in the UI arrives as `[null, null]` — it is normalised
 * to `null` so the stored value matches `CustomFieldValueMap['dateRange']`.
 */
const customFieldValueSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.date(),
    z.array(z.string()),
    z
        .tuple([z.date().nullable(), z.date().nullable()])
        .transform((range): [Date, Date] | null => (range[0] && range[1] ? [range[0], range[1]] : null)),
    z.instanceof(Decimal),
    z.null(),
]);

/**
 * Validated counterpart of the `CustomFieldsData` type — its output is
 * assignable to `Record<string, CustomFieldValue>`.
 */
export const customFieldsDataSchema = z.record(z.string(), customFieldValueSchema.optional());
